import { Event } from '../types';

/**
 * Curated image catalogue (unchanged from your version).
 * Tip: keep each list's first/neutral image broadly representative.
 */
const categoryImages: Record<string, string[]> = {
  '🌲 Outdoors & Adventures': [
    'https://images.unsplash.com/photo-1501555088652-021faa106b9b?ixlib=rb-4.0.3&auto=format&fit=crop&w=1200&q=75', // Hiking / outdoors (neutral)
    'https://images.unsplash.com/photo-1517457373958-b7bdd4587205?ixlib=rb-4.0.3&auto=format&fit=crop&w=2070&q=80', // Cycling group
    'https://images.unsplash.com/photo-1527751171053-6ac5ec50000b?ixlib=rb-4.0.3&auto=format&fit=crop&w=2070&q=80', // Friends hiking
    'https://images.unsplash.com/photo-1530866495561-507c9faab2ed?ixlib=rb-4.0.3&auto=format&fit=crop&w=2070&q=80', // Kayaking
    'https://images.unsplash.com/photo-1504280390367-361c6d9f38f4?ixlib=rb-4.0.3&auto=format&fit=crop&w=2070&q=80', // Camping
  ],
  '🍕 Food & Drink': [
    'https://images.unsplash.com/photo-1517248135467-4c7edcad34c4?ixlib=rb-4.0.3&auto=format&fit=crop&w=2070&q=80', // Restaurant / coffee-ish neutral
    'https://images.unsplash.com/photo-1528605248644-14dd04022da1?ixlib=rb-4.0.3&auto=format&fit=crop&w=2070&q=80', // Friends dining
    'https://images.unsplash.com/photo-1519671482749-fd09be7ccebf?ixlib=rb-4.0.3&auto=format&fit=crop&w=2070&q=80', // Cooking together
    'https://images.unsplash.com/photo-1543007630-9710e4a00a20?ixlib=rb-4.0.3&auto=format&fit=crop&w=2070&q=80', // Food festival
    'https://images.unsplash.com/photo-1414235077428-338989a2e8c0?ixlib=rb-4.0.3&auto=format&fit=crop&w=2070&q=80', // Food spread
  ],
  '💪 Fitness & Wellness': [
    'https://images.unsplash.com/photo-1571019613454-1cb2f99b2d8b?ixlib=rb-4.0.3&auto=format&fit=crop&w=2070&q=80', // Group yoga (neutral)
    'https://images.unsplash.com/photo-1518611012118-696072aa579a?ixlib=rb-4.0.3&auto=format&fit=crop&w=2070&q=80', // Meditation
    'https://images.unsplash.com/photo-1517836357463-d25dfeac3438?ixlib=rb-4.0.3&auto=format&fit=crop&w=2070&q=80', // Fitness class
    'https://images.unsplash.com/photo-1517130038641-a774d04afb3c?ixlib=rb-4.0.3&auto=format&fit=crop&w=2070&q=80', // Running group
    'https://images.unsplash.com/photo-1549060279-7e168fcee0c2?ixlib=rb-4.0.3&auto=format&fit=crop&w=2070&q=80', // Wellness retreat
  ],
  '🎨 Art & Creative Stuff': [
    'https://images.unsplash.com/photo-1607346256330-dee7af15f7c5?ixlib=rb-4.0.3&auto=format&fit=crop&w=2070&q=80', // Painting (neutral)
    'https://images.unsplash.com/photo-1560421683-6856ea585c78?ixlib=rb-4.0.3&auto=format&fit=crop&w=2070&q=80', // Pottery
    'https://images.unsplash.com/photo-1452860606245-08befc0ff44b?ixlib=rb-4.0.3&auto=format&fit=crop&w=2070&q=80', // Art workshop
    'https://images.unsplash.com/photo-1605721911519-3dfeb3be25e7?ixlib=rb-4.0.3&auto=format&fit=crop&w=2070&q=80', // Crafting
    'https://images.unsplash.com/photo-1513364776144-60967b0f800f?ixlib=rb-4.0.3&auto=format&fit=crop&w=2070&q=80', // Gallery
  ],
  '🎭 Shows, Movies & Fun': [
    'https://images.unsplash.com/photo-1507676184212-d03ab07a01bf?ixlib=rb-4.0.3&auto=format&fit=crop&w=2070&q=80', // Theatre (neutral)
    'https://images.unsplash.com/photo-1585699324551-f6c309eedeca?ixlib=rb-4.0.3&auto=format&fit=crop&w=2070&q=80', // Stage
    'https://images.unsplash.com/photo-1603190287605-e6ade32fa852?ixlib=rb-4.0.3&auto=format&fit=crop&w=2070&q=80', // Comedy
    'https://images.unsplash.com/photo-1460723237483-7a6dc9d0b212?ixlib=rb-4.0.3&auto=format&fit=crop&w=2070&q=80', // Performance
    'https://images.unsplash.com/photo-1478720568477-152d9b164e26?ixlib=rb-4.0.3&auto=format&fit=crop&w=2070&q=80', // Movie theatre
  ],
  '🎶 Music & Festivals': [
    'https://images.unsplash.com/photo-1459749411175-04bf5292ceea?ixlib=rb-4.0.3&auto=format&fit=crop&w=2070&q=80', // Concert (neutral)
    'https://images.unsplash.com/photo-1533174072545-7a4b6ad7a6c3?ixlib=rb-4.0.3&auto=format&fit=crop&w=2070&q=80', // Festival
    'https://images.unsplash.com/photo-1501612780327-45045538702b?ixlib=rb-4.0.3&auto=format&fit=crop&w=2070&q=80', // Live band
    'https://images.unsplash.com/photo-1470229722913-7c0e2dbbafd3?ixlib=rb-4.0.3&auto=format&fit=crop&w=2070&q=80', // Music event
    'https://images.unsplash.com/photo-1506157786151-b8491531f063?ixlib=rb-4.0.3&auto=format&fit=crop&w=2070&q=80', // DJ
  ],
  '🎮 Gaming & Board Games': [
    'https://images.unsplash.com/photo-1511882150382-421056c89033?ixlib=rb-4.0.3&auto=format&fit=crop&w=2070&q=80', // Board games (neutral)
    'https://images.unsplash.com/photo-1560419015-7c427e8ae5ba?ixlib=rb-4.0.3&auto=format&fit=crop&w=2070&q=80', // Video gaming
    'https://images.unsplash.com/photo-1610890716171-6b1bb98ffd09?ixlib=rb-4.0.3&auto=format&fit=crop&w=2070&q=80', // Chess
    'https://images.unsplash.com/photo-1606167668584-78701c57f13d?ixlib=rb-4.0.3&auto=format&fit=crop&w=2070&q=80', // Gaming party
    'https://images.unsplash.com/photo-1523843268911-45a882919fec?ixlib=rb-4.0.3&auto=format&fit=crop&w=2070&q=80', // Card games
  ],
  '🏟️ Sports & Events': [
    'https://images.unsplash.com/photo-1461896836934-ffe607ba8211?ixlib=rb-4.0.3&auto=format&fit=crop&w=2070&q=80', // Stadium (neutral)
    'https://images.unsplash.com/photo-1547347298-4074fc3086f0?ixlib=rb-4.0.3&auto=format&fit=crop&w=2070&q=80', // Soccer match
    'https://images.unsplash.com/photo-1587280501635-68a0e82cd5ff?ixlib=rb-4.0.3&auto=format&fit=crop&w=2070&q=80', // Basketball
    'https://images.unsplash.com/photo-1517649763962-0c623066013b?ixlib=rb-4.0.3&auto=format&fit=crop&w=2070&q=80', // Tennis
    'https://images.unsplash.com/photo-1540747913346-19e32dc3e97e?ixlib=rb-4.0.3&auto=format&fit=crop&w=2070&q=80', // Sports event
  ],
  '✈️ Travel & Day Trips': [
    'https://images.unsplash.com/photo-1527631746610-bca00a040d60?ixlib=rb-4.0.3&auto=format&fit=crop&w=2070&q=80', // Group travel (neutral)
    'https://images.unsplash.com/photo-1473496169904-658ba7c44d8a?ixlib=rb-4.0.3&auto=format&fit=crop&w=2070&q=80', // Road trip
    'https://images.unsplash.com/photo-1522878129833-838a904a0e9e?ixlib=rb-4.0.3&auto=format&fit=crop&w=2070&q=80', // Friends traveling
    'https://images.unsplash.com/photo-1504150558240-0b4fd8946624?ixlib=rb-4.0.3&auto=format&fit=crop&w=2070&q=80', // Sightseeing
    'https://images.unsplash.com/photo-1488085061387-422e29b40080?ixlib=rb-4.0.3&auto=format&fit=crop&w=2070&q=80', // City exploration
  ],
  '🧠 Learn Something New': [
    'https://images.unsplash.com/photo-1524178232363-1fb2b075b655?ixlib=rb-4.0.3&auto=format&fit=crop&w=2070&q=80', // Workshop (neutral)
    'https://images.unsplash.com/photo-1522202176988-66273c2fd55f?ixlib=rb-4.0.3&auto=format&fit=crop&w=2070&q=80', // Study group
    'https://images.unsplash.com/photo-1524995997946-a1c2e315a42f?ixlib=rb-4.0.3&auto=format&fit=crop&w=2070&q=80', // Learning session
    'https://images.unsplash.com/photo-1531545514256-b1400bc00f31?ixlib=rb-4.0.3&auto=format&fit=crop&w=2070&q=80', // Presentation
    'https://images.unsplash.com/photo-1503676260728-1c00da094a0b?ixlib=rb-4.0.3&auto=format&fit=crop&w=2070&q=80', // Educational event
  ],
  '🗣️ Meetups & Socials': [
    'https://images.unsplash.com/photo-1529156069898-49953e39b3ac?ixlib=rb-4.0.3&auto=format&fit=crop&w=2070&q=80', // Social gathering (neutral)
    'https://images.unsplash.com/photo-1511632765486-a01980e01a18?ixlib=rb-4.0.3&auto=format&fit=crop&w=2070&q=80', // Networking
    'https://images.unsplash.com/photo-1540317580256-e5d1c3fe4895?ixlib=rb-4.0.3&auto=format&fit=crop&w=2070&q=80', // Party
    'https://images.unsplash.com/photo-1528605248644-14dd04022da1?ixlib=rb-4.0.3&auto=format&fit=crop&w=2070&q=80', // Friends hanging out
    'https://images.unsplash.com/photo-1511795409834-ef04bbd61622?ixlib=rb-4.0.3&auto=format&fit=crop&w=2070&q=80', // Casual meetup
  ],
  '🤝 Volunteering & Good Vybes': [
    'https://images.unsplash.com/photo-1559027615-cd4628902d4a?ixlib=rb-4.0.3&auto=format&fit=crop&w=2070&q=80', // Volunteering (neutral)
    'https://images.unsplash.com/photo-1544374944-56d4d3e4397e?ixlib=rb-4.0.3&auto=format&fit=crop&w=2070&q=80', // Community service
    'https://images.unsplash.com/photo-1560252829-804f1aedf1be?ixlib=rb-4.0.3&auto=format&fit=crop&w=2070&q=80', // Charity
    'https://images.unsplash.com/photo-1593113598332-cd59a93f9724?ixlib=rb-4.0.3&auto=format&fit=crop&w=2070&q=80', // Beach cleanup
    'https://images.unsplash.com/photo-1488521787991-ed7bbaae773c?ixlib=rb-4.0.3&auto=format&fit=crop&w=2070&q=80', // Community help
  ],
  '👗 Fashion & Style': [
    'https://images.unsplash.com/photo-1490481651871-ab68de25d43d?ixlib=rb-4.0.3&auto=format&fit=crop&w=2070&q=80', // Fashion event (neutral)
    'https://images.unsplash.com/photo-1576566588028-4147f3842f27?ixlib=rb-4.0.3&auto=format&fit=crop&w=2070&q=80', // Style workshop
    'https://images.unsplash.com/photo-1529139574466-a303027c1d8b?ixlib=rb-4.0.3&auto=format&fit=crop&w=2070&q=80', // Fashion show
    'https://images.unsplash.com/photo-1607083206968-13611e3d76db?ixlib=rb-4.0.3&auto=format&fit=crop&w=2070&q=80', // Clothing swap
    'https://images.unsplash.com/photo-1558769132-cb1aea458c5e?ixlib=rb-4.0.3&auto=format&fit=crop&w=2070&q=80', // Style meetup
  ],
  '💻 Tech & Gadgets': [
    'https://images.unsplash.com/photo-1504384308090-c894fdcc538d?ixlib=rb-4.0.3&auto=format&fit=crop&w=2070&q=80', // Tech meetup (neutral)
    'https://images.unsplash.com/photo-1523240795612-9a054b0db644?ixlib=rb-4.0.3&auto=format&fit=crop&w=2070&q=80', // Coding workshop
    'https://images.unsplash.com/photo-1517048676732-d65bc937f952?ixlib=rb-4.0.3&auto=format&fit=crop&w=2070&q=80', // Tech conference
    'https://images.unsplash.com/photo-1573496359142-b8475f639467?ixlib=rb-4.0.3&auto=format&fit=crop&w=2070&q=80', // Gadget showcase
    'https://images.unsplash.com/photo-1581091226825-a6a2a5aee158?ixlib=rb-4.0.3&auto=format&fit=crop&w=2070&q=80', // Enthusiasts
  ],
  '📚 Books & Chill': [
    'https://images.unsplash.com/photo-1529148482759-b35b25c5f217?ixlib=rb-4.0.3&auto=format&fit=crop&w=2070&q=80', // Book club (neutral)
    'https://images.unsplash.com/photo-1513475382585-d06e58bcb0e0?ixlib=rb-4.0.3&auto=format&fit=crop&w=2070&q=80', // Reading group
    'https://images.unsplash.com/photo-1519682337058-a94d519337bc?ixlib=rb-4.0.3&auto=format&fit=crop&w=2070&q=80', // Library
    'https://images.unsplash.com/photo-1481627834876-b7833e8f5570?ixlib=rb-4.0.3&auto=format&fit=crop&w=2070&q=80', // Discussion
    'https://images.unsplash.com/photo-1456513080510-7bf3a84b82f8?ixlib=rb-4.0.3&auto=format&fit=crop&w=2070&q=80', // Cozy reading
  ],
  '🐶 Pets & Animals': [
    'https://images.unsplash.com/photo-1548199973-03cce0bbc87b?ixlib=rb-4.0.3&auto=format&fit=crop&w=2070&q=80', // Dog meetup (neutral)
    'https://images.unsplash.com/photo-1541888946425-d81bb19240f5?ixlib=rb-4.0.3&auto=format&fit=crop&w=2070&q=80', // Pet event
    'https://images.unsplash.com/photo-1494947665470-20322015e3a8?ixlib=rb-4.0.3&auto=format&fit=crop&w=2070&q=80', // Animal lovers
    'https://images.unsplash.com/photo-1534361960057-19889db9621e?ixlib=rb-4.0.3&auto=format&fit=crop&w=2070&q=80', // Pet adoption
    'https://images.unsplash.com/photo-1503256207526-0d5d80fa2f47?ixlib=rb-4.0.3&auto=format&fit=crop&w=2070&q=80', // Animal care
  ],
  '💃 Dance & Movement': [
    'https://images.unsplash.com/photo-1508700115892-45ecd05ae2ad?ixlib=rb-4.0.3&auto=format&fit=crop&w=2070&q=80', // Dance class (neutral)
    'https://images.unsplash.com/photo-1504609773096-104ff2c73ba4?ixlib=rb-4.0.3&auto=format&fit=crop&w=2070&q=80', // Performance
    'https://images.unsplash.com/photo-1516450360452-9312f5e86fc7?ixlib=rb-4.0.3&auto=format&fit=crop&w=2070&q=80', // Group dancing
    'https://images.unsplash.com/photo-1547153760-18fc86324498?ixlib=rb-4.0.3&auto=format&fit=crop&w=2070&q=80', // Workshop
    'https://images.unsplash.com/photo-1535525153412-5a42439a210d?ixlib=rb-4.0.3&auto=format&fit=crop&w=2070&q=80', // Movement
  ],
};

// Use this for consistent “neutral” fallback per category (index into the arrays above).
const NEUTRAL_INDEX: Record<string, number> = {
  '🌲 Outdoors & Adventures': 0,
  '🍕 Food & Drink': 0,
  '💪 Fitness & Wellness': 0,
  '🎨 Art & Creative Stuff': 0,
  '🎭 Shows, Movies & Fun': 0,
  '🎶 Music & Festivals': 0,
  '🎮 Gaming & Board Games': 0,
  '🏟️ Sports & Events': 0,
  '✈️ Travel & Day Trips': 0,
  '🧠 Learn Something New': 0,
  '🗣️ Meetups & Socials': 0,
  '🤝 Volunteering & Good Vybes': 0,
  '👗 Fashion & Style': 0,
  '💻 Tech & Gadgets': 0,
  '📚 Books & Chill': 0,
  '🐶 Pets & Animals': 0,
  '💃 Dance & Movement': 0,
};

// Synonym/alias normalisation (DB likely stores simple names)
const CATEGORY_ALIASES: Record<string, string> = {
  'outdoors & adventures': '🌲 Outdoors & Adventures',
  'outdoors': '🌲 Outdoors & Adventures',
  'adventure': '🌲 Outdoors & Adventures',

  'food & drink': '🍕 Food & Drink',
  'food': '🍕 Food & Drink',
  'coffee': '🍕 Food & Drink',

  'fitness & wellness': '💪 Fitness & Wellness',
  'fitness': '💪 Fitness & Wellness',
  'wellness': '💪 Fitness & Wellness',

  'art & creative stuff': '🎨 Art & Creative Stuff',
  'art': '🎨 Art & Creative Stuff',
  'creative': '🎨 Art & Creative Stuff',

  'shows, movies & fun': '🎭 Shows, Movies & Fun',
  'shows': '🎭 Shows, Movies & Fun',
  'movies': '🎭 Shows, Movies & Fun',
  'films': '🎭 Shows, Movies & Fun',

  'music & festivals': '🎶 Music & Festivals',
  'music': '🎶 Music & Festivals',
  'festival': '🎶 Music & Festivals',

  'gaming & board games': '🎮 Gaming & Board Games',
  'board games': '🎮 Gaming & Board Games',
  'gaming': '🎮 Gaming & Board Games',

  'sports & events': '🏟️ Sports & Events',
  'sports': '🏟️ Sports & Events',

  'travel & day trips': '✈️ Travel & Day Trips',
  'travel': '✈️ Travel & Day Trips',
  'day trips': '✈️ Travel & Day Trips',

  'learn something new': '🧠 Learn Something New',
  'learn': '🧠 Learn Something New',

  'meetups & socials': '🗣️ Meetups & Socials',
  'meetups': '🗣️ Meetups & Socials',
  'socials': '🗣️ Meetups & Socials',

  'volunteering & good vibes': '🤝 Volunteering & Good Vybes',
  'volunteering': '🤝 Volunteering & Good Vybes',

  'fashion & style': '👗 Fashion & Style',
  'fashion': '👗 Fashion & Style',
  'style': '👗 Fashion & Style',

  'tech & gadgets': '💻 Tech & Gadgets',
  'tech': '💻 Tech & Gadgets',
  'gadgets': '💻 Tech & Gadgets',

  'books & chill': '📚 Books & Chill',
  'books': '📚 Books & Chill',
  'reading': '📚 Books & Chill',

  'pets & animals': '🐶 Pets & Animals',
  'pets': '🐶 Pets & Animals',
  'animals': '🐶 Pets & Animals',

  'dance & movement': '💃 Dance & Movement',
  'dance': '💃 Dance & Movement',
};

// More on-brand default: people socializing outdoors (warm, friendly, active)
const defaultImage =
  'https://images.unsplash.com/photo-1511632765486-a01980e01a18?ixlib=rb-4.0.3&auto=format&fit=crop&w=1200&q=75';

/**
 * Optimize Unsplash URL to reduce egress
 * Changes w=2070&q=80 to w=1200&q=75 (saves ~60% bandwidth)
 */
function optimizeImageUrl(url: string): string {
  if (url.includes('unsplash.com')) {
    return url.replace(/w=2070&q=80/, 'w=1200&q=75');
  }
  return url;
}

/** Lowercase + strip emojis/punctuation for reliable matching */
function normalise(s: string | null | undefined): string {
  return (s || '')
    .toLowerCase()
    .replace(/[\u{1F300}-\u{1FAFF}]/gu, '') // emojis
    .replace(/[^\w\s&-]+/g, '')
    .trim();
}

function resolveCategory(raw: string | null | undefined): string | undefined {
  const key = normalise(raw);
  if (!key) return undefined;
  return CATEGORY_ALIASES[key] || Object.keys(categoryImages).find(cat => normalise(cat) === key);
}

// Keyword → precise image, to avoid mismatches
const KEYWORDS: Array<[RegExp, string]> = [
  // Sports - specific keywords first (more specific patterns come first)
  [/\b(five[\s-]?a[\s-]?side|5[\s-]?a[\s-]?side)\b/i, categoryImages['🏟️ Sports & Events'][1]], // soccer match
  [/\b(football|soccer|futsal)\b/i, categoryImages['🏟️ Sports & Events'][1]], // soccer match
  [/\b(basketball|hoops)\b/i, categoryImages['🏟️ Sports & Events'][2]],
  [/\b(tennis|racquet|racket)\b/i, categoryImages['🏟️ Sports & Events'][3]],

  // Outdoors - walks vs hikes distinction
  [/\b(walk|stroll|walking)\b(?!.*\b(mountain|hill|trek|trail)\b)/i, 'https://images.unsplash.com/photo-1551632811-561732d1e306?ixlib=rb-4.0.3&auto=format&fit=crop&w=2070&q=80'], // peaceful park walk
  [/\b(hike|hiking|trek|trail|mountain)\b/i, categoryImages['🌲 Outdoors & Adventures'][2]], // friends hiking
  [/\b(cycling|bike|biking|bicycle|cycle)\b/i, categoryImages['🌲 Outdoors & Adventures'][1]], // cycling
  [/\b(kayak|canoe|paddle|watersport|rowing)\b/i, categoryImages['🌲 Outdoors & Adventures'][3]], // kayaking
  [/\b(camp|camping|campfire|tent)\b/i, categoryImages['🌲 Outdoors & Adventures'][4]],

  // Food & Drink
  [/\b(coffee|cafe|espresso|latte|cappuccino)\b/i, categoryImages['🍕 Food & Drink'][0]],
  [/\b(brunch|breakfast|lunch|dinner|restaurant)\b/i, categoryImages['🍕 Food & Drink'][1]],
  [/\b(cooking|cook|chef|kitchen)\b/i, categoryImages['🍕 Food & Drink'][2]],

  // Gaming
  [/\b(board\s?game|boardgame|tabletop|catan|monopoly)\b/i, categoryImages['🎮 Gaming & Board Games'][0]], // board games neutral
  [/\b(chess|checkers)\b/i, categoryImages['🎮 Gaming & Board Games'][2]],
  [/\b(gaming|video\s?game|lan|esport|ps5|xbox|switch)\b/i, categoryImages['🎮 Gaming & Board Games'][1]],

  // Entertainment
  [/\b(movie|cinema|film)\b/i, categoryImages['🎭 Shows, Movies & Fun'][4]],
  [/\b(theatre|theater|show|play|musical)\b/i, categoryImages['🎭 Shows, Movies & Fun'][0]],

  // Fitness
  [/\b(dance|zumba|salsa|tango|ballet)\b/i, categoryImages['💃 Dance & Movement'][0]],
  [/\b(run|running|jog|jogging|marathon|parkrun)\b/i, categoryImages['💪 Fitness & Wellness'][3]],
  [/\b(yoga|meditation|wellness|pilates|mindfulness)\b/i, categoryImages['💪 Fitness & Wellness'][0]],
  [/\b(gym|fitness|workout|training|exercise)\b/i, categoryImages['💪 Fitness & Wellness'][2]],

  // Other categories
  [/\b(volunteer|community|charity|cleanup|clean-up)\b/i, categoryImages['🤝 Volunteering & Good Vybes'][0]],
  [/\b(music|concert|gig|festival|dj|band|live music)\b/i, categoryImages['🎶 Music & Festivals'][0]],
  [/\b(book|reading|library|book club|literature)\b/i, categoryImages['📚 Books & Chill'][0]],
  [/\b(tech|coding|programming|hackathon|developer|startup)\b/i, categoryImages['💻 Tech & Gadgets'][0]],
  [/\b(art|painting|drawing|pottery|craft|creative)\b/i, categoryImages['🎨 Art & Creative Stuff'][0]],
  [/\b(travel|trip|tour|sightseeing|day\s?trip|explore)\b/i, categoryImages['✈️ Travel & Day Trips'][0]],
];

/**
 * Public API
 */

// Keep this helper if you ever need true randomness (e.g., seed pages).
export const getRandomEventImage = (category: string): string => {
  const resolved = resolveCategory(category) || category;
  const images = categoryImages[resolved];
  if (!images || images.length === 0) return defaultImage;
  const randomIndex = Math.floor(Math.random() * images.length);
  return images[randomIndex];
};

// Deterministic, mismatch-averse chooser for a specific event.
export const getEventImage = (event: Event): string => {
  // Prioritize custom event image if available
  if (event.imageUrl && event.imageGenerationStatus === 'completed') {
    return event.imageUrl;
  }

  // Fallback to category images (EventCard component handles pending/generating status separately)
  const title = event?.title || '';
  const rawCategory = event?.category || '';

  // 2) Title keywords (strongest signal)
  const haystack = `${title} ${rawCategory}`;
  for (const [re, url] of KEYWORDS) {
    if (re.test(haystack)) return optimizeImageUrl(url);
  }

  // 3) Category fallback (neutral image)
  const resolved = resolveCategory(rawCategory);
  if (resolved && categoryImages[resolved]?.length) {
    const neutralIdx = NEUTRAL_INDEX[resolved] ?? 0;
    const fallbackUrl = categoryImages[resolved][neutralIdx] || categoryImages[resolved][0];
    return optimizeImageUrl(fallbackUrl);
  }

  // 4) Absolute fallback
  return defaultImage;
};

// All curated images for a (normalised) category.
export const getCategoryImages = (category: string): string[] => {
  const resolved = resolveCategory(category) || category;
  return categoryImages[resolved] || [defaultImage];
};

// Available categories (as displayed to users)
export const getAvailableCategories = (): string[] => Object.keys(categoryImages);
